module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/main-visual-4359da1582f700b7bb7375686b190515.jpg";